import {NgModule} from '@angular/core';
import {NgxsModule} from '@ngxs/store';
import {RouterState} from './router.state';

@NgModule({
  imports: [NgxsModule.forFeature([RouterState])],
})
export class NgxsUiRouterPluginModule {}
